export default __webpack_public_path__ + "static/media/bread-crumb-angle.7c23e30e.svg";